window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.Relatorios = window.FazendaRP.Pages.Relatorios || {};

window.FazendaRP.Pages.Relatorios.Balanco = {

    render: async function (container) {
        // 1. Inject CSS if not present
        if (!document.getElementById('css-balanco')) {
            const link = document.createElement('link');
            link.id = 'css-balanco';
            link.rel = 'stylesheet';
            link.href = 'css/balanco.css';
            document.head.appendChild(link);
        }

        // 2. Base HTML Structure
        container.innerHTML = `
            <div class="balanco-container" style="padding:0; margin:0; width:100%; max-width:none;">
                
                <!-- Controls -->
                <div class="balanco-header" style="margin-bottom:20px; border:1px solid #e2e8f0; box-shadow:none;">
                    <div class="header-controls" style="width:100%; justify-content:space-between;">
                        <div style="display:flex; gap:10px; align-items:center;">
                            <label style="font-weight:600; color:#64748b;">Referência:</label>
                            <input type="date" id="balanco-data-ref" class="form-control" style="padding:8px;">
                            <button class="btn-gerar" onclick="window.FazendaRP.Pages.Relatorios.Balanco.carregarDados()">
                                <i class="fas fa-sync-alt"></i> Atualizar
                            </button>
                        </div>
                        <div class="validacao-box" id="balanco-validacao" style="margin:0; padding:8px 20px; font-size:0.9rem;">
                            ...
                        </div>
                    </div>
                </div>

                <!-- Grid Principal -->
                <div class="balanco-grid" style="gap:20px;">
                    
                    <!-- ATIVO -->
                    <div class="balanco-coluna ativo" style="box-shadow:none; border:1px solid #e2e8f0; border-top: 4px solid #10b981;">
                        <div class="coluna-header">
                            <i class="fas fa-arrow-trend-up" style="color: #10b981;"></i>
                            <h2>ATIVO</h2>
                        </div>

                        <!-- 1. Circulante -->
                        <div class="balanco-secao">
                            <div class="secao-titulo"><i class="fas fa-wallet"></i> Ativo Circulante</div>
                            <div id="lista-ativo-circulante"></div>
                            <div class="subtotal"><span>Total Circulante</span><span id="tot-ativo-circ">R$ 0,00</span></div>
                        </div>

                        <!-- 2. Realizável LP -->
                        <div class="balanco-secao">
                            <div class="secao-titulo"><i class="fas fa-hourglass-half"></i> Realizável a Longo Prazo</div>
                            <div id="lista-ativo-realizavel"></div>
                            <div class="subtotal"><span>Total Realizável LP</span><span id="tot-ativo-real">R$ 0,00</span></div>
                        </div>

                        <!-- 3. Imobilizado -->
                        <div class="balanco-secao">
                            <div class="secao-titulo"><i class="fas fa-tractor"></i> Ativo Imobilizado</div>
                            <div id="lista-ativo-imobilizado"></div>
                            <div class="subtotal"><span>Total Imobilizado</span><span id="tot-ativo-imob">R$ 0,00</span></div>
                        </div>

                        <div class="balanco-total">
                            <span>TOTAL ATIVO</span>
                            <span id="grand-tot-ativo">R$ 0,00</span>
                        </div>
                    </div>

                    <!-- PASSIVO -->
                    <div class="balanco-coluna passivo" style="box-shadow:none; border:1px solid #e2e8f0; border-top: 4px solid #ef4444;">
                        <div class="coluna-header">
                            <i class="fas fa-arrow-trend-down" style="color: #ef4444;"></i>
                            <h2>PASSIVO + PL</h2>
                        </div>

                        <!-- 1. Circulante -->
                        <div class="balanco-secao">
                            <div class="secao-titulo"><i class="fas fa-file-invoice-dollar"></i> Passivo Circulante</div>
                            <div id="lista-passivo-circulante"></div>
                            <div class="subtotal"><span>Total Circulante</span><span id="tot-passivo-circ">R$ 0,00</span></div>
                        </div>

                        <!-- 2. Não Circulante -->
                        <div class="balanco-secao">
                            <div class="secao-titulo"><i class="fas fa-landmark"></i> Passivo Não Circulante</div>
                            <div id="lista-passivo-nao"></div>
                            <div class="subtotal"><span>Total Não Circulante</span><span id="tot-passivo-nao">R$ 0,00</span></div>
                        </div>

                        <!-- 3. PL -->
                        <div class="balanco-secao secao-pl">
                            <div class="secao-titulo"><i class="fas fa-gem"></i> Patrimônio Líquido</div>
                            <div id="lista-pl"></div>
                            <div class="subtotal"><span>Total PL</span><span id="tot-pl">R$ 0,00</span></div>
                        </div>

                        <div class="balanco-total">
                            <span>TOTAL PASSIVO + PL</span>
                            <span id="grand-tot-passivo">R$ 0,00</span>
                        </div>
                    </div>
                </div>

                <!-- Indicadores -->
                 <div class="indicadores-grid" style="margin-top:20px;">
                    <div class="indicador-card">
                        <div class="ind-titulo">Liquidez Corrente</div>
                        <div class="ind-valor" id="ind-liquidez">-</div>
                    </div>
                    <div class="indicador-card">
                        <div class="ind-titulo">Endividamento</div>
                        <div class="ind-valor" id="ind-endividamento">-</div>
                    </div>
                    <div class="indicador-card">
                        <div class="ind-titulo">Patrimônio Líquido</div>
                        <div class="ind-valor" id="ind-pl">-</div>
                    </div>
                </div>
            </div>
        `;

        // Set Date
        document.getElementById('balanco-data-ref').valueAsDate = new Date();

        // Load Data
        this.carregarDados();
    },

    carregarDados: async function () {
        const dataRef = document.getElementById('balanco-data-ref').value;
        const loading = (el) => el.innerHTML = '<div style="padding:10px; color:#94a3b8; text-align:center;"><i class="fas fa-spinner fa-spin"></i></div>';

        // Set Loaders
        ['ativo-circulante', 'ativo-realizavel', 'ativo-imobilizado', 'passivo-circulante', 'passivo-nao', 'pl'].forEach(id => {
            const el = document.getElementById('lista-' + id);
            if (el) loading(el);
        });

        try {
            // ------------------------------------
            // 1. FETCH DATA PARALLEL
            // ------------------------------------
            const [
                { data: contas },
                { data: movs_balance },
                { data: frota },
                { data: estoque },
                { data: lancamentos } // Para contas a receber/pagar
            ] = await Promise.all([
                window.FazendaRP.supabase.from('financeiro_contas').select('*'),
                window.FazendaRP.supabase.from('financeiro_movimentacoes').select('valor, tipo, conta_id').neq('status', 'Cancelado'),
                window.FazendaRP.supabase.from('frota_veiculos').select('*').eq('status', 'Ativo'),
                window.FazendaRP.supabase.from('suprimentos_estoque').select('valor_total_estoque'),
                window.FazendaRP.supabase.from('financeiro_lancamentos')
                    .select('valor, tipo, status, data_vencimento, categoria')
                    .neq('status', 'Pago')
                    .neq('status', 'Cancelado')
            ]);

            const fmt = (v) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            const parse = (v) => typeof v === 'number' ? v : parseFloat(v || 0);

            // ------------------------------------
            // CALC: ATIVO CIRCULANTE
            // ------------------------------------
            // 1.1 Caixa e Bancos
            const totalCaixaInitial = contas.reduce((acc, c) => acc + parse(c.saldo_inicial), 0);
            const totalCaixaMovs = movs_balance.reduce((acc, m) => {
                const val = parse(m.valor);
                return acc + (m.tipo === 'CREDITO' ? val : -val);
            }, 0);
            const totalCaixa = totalCaixaInitial + totalCaixaMovs;

            // 1.2 Estoque
            const totalEstoque = estoque.reduce((acc, e) => acc + parse(e.valor_total_estoque), 0);

            // 1.3 Contas a Receber (CP < 365 dias)
            const hoje = new Date(dataRef);
            const anoQueVem = new Date(hoje);
            anoQueVem.setFullYear(anoQueVem.getFullYear() + 1);

            const aReceberCP = lancamentos
                .filter(l => l.tipo === 'Receita' && new Date(l.data_vencimento) <= anoQueVem)
                .reduce((acc, l) => acc + parse(l.valor), 0);

            let htmlAtivoCirc = `
                <div class="conta-item"><span class="conta-nome"><i class="fas fa-university"></i> Caixa e Bancos</span><span class="conta-valor">${fmt(totalCaixa)}</span></div>
                <div class="conta-item"><span class="conta-nome"><i class="fas fa-boxes"></i> Estoque</span><span class="conta-valor">${fmt(totalEstoque)}</span></div>
                <div class="conta-item"><span class="conta-nome"><i class="fas fa-hand-holding-dollar"></i> Contas a Receber (CP)</span><span class="conta-valor">${fmt(aReceberCP)}</span></div>
            `;
            document.getElementById('lista-ativo-circulante').innerHTML = htmlAtivoCirc;

            const totalAtivoCirc = totalCaixa + totalEstoque + aReceberCP;
            document.getElementById('tot-ativo-circ').textContent = fmt(totalAtivoCirc);


            // ------------------------------------
            // CALC: ATIVO REALIZÁVEL LP
            // ------------------------------------
            // 2.1 Contas a Receber LP (> 365 dias)
            const aReceberLP = lancamentos
                .filter(l => l.tipo === 'Receita' && new Date(l.data_vencimento) > anoQueVem)
                .reduce((acc, l) => acc + parse(l.valor), 0);

            // 2.2 Consórcios e Capitalização (Placeholder por enquanto, depois virá do banco)
            const consorcios = 0; // TODO: Implementar módulo

            let htmlAtivoReal = `
                <div class="conta-item"><span class="conta-nome"><i class="fas fa-calendar-plus"></i> Contas a Receber (LP)</span><span class="conta-valor">${fmt(aReceberLP)}</span></div>
                <div class="conta-item"><span class="conta-nome"><i class="fas fa-handshake"></i> Consórcios (Em breve)</span><span class="conta-valor">${fmt(consorcios)}</span></div>
            `;
            document.getElementById('lista-ativo-realizavel').innerHTML = htmlAtivoReal;

            const totalAtivoReal = aReceberLP + consorcios;
            document.getElementById('tot-ativo-real').textContent = fmt(totalAtivoReal);


            // ------------------------------------
            // CALC: ATIVO IMOBILIZADO
            // ------------------------------------
            // 3.1 Frota (Valor Mercado/Gerencial)
            // Se tiver 'valor_atual', usa ele, senão usa 'valor_aquisicao'
            const totalFrota = frota.reduce((acc, v) => {
                const val = v.valor_atual !== null ? v.valor_atual : v.valor_aquisicao;
                return acc + parse(val);
            }, 0);

            // 3.2 Benfeitorias (Exemplo fixo ou DB)
            const totalBenfeitorias = 0;

            let htmlAtivoImob = `
                <div class="conta-item"><span class="conta-nome"><i class="fas fa-truck-monster"></i> Frota (Valor Mercado)</span><span class="conta-valor">${fmt(totalFrota)}</span></div>
                <div class="conta-item"><span class="conta-nome"><i class="fas fa-warehouse"></i> Benfeitorias</span><span class="conta-valor">${fmt(totalBenfeitorias)}</span></div>
            `;
            document.getElementById('lista-ativo-imobilizado').innerHTML = htmlAtivoImob;

            const totalAtivoImob = totalFrota + totalBenfeitorias;
            document.getElementById('tot-ativo-imob').textContent = fmt(totalAtivoImob);

            // GRAND TOTAL ATIVO
            const grandAtivo = totalAtivoCirc + totalAtivoReal + totalAtivoImob;
            document.getElementById('grand-tot-ativo').textContent = fmt(grandAtivo);


            // ------------------------------------
            // CALC: PASSIVO CIRCULANTE
            // ------------------------------------
            const aPagarCP = lancamentos
                .filter(l => (l.tipo === 'Despesa' || l.tipo === 'Saída') && new Date(l.data_vencimento) <= anoQueVem)
                .reduce((acc, l) => acc + parse(l.valor), 0);

            let htmlPassivoCirc = `
                <div class="conta-item"><span class="conta-nome"><i class="fas fa-file-invoice"></i> Fornecedores/Contas (CP)</span><span class="conta-valor">${fmt(aPagarCP)}</span></div>
            `;
            document.getElementById('lista-passivo-circulante').innerHTML = htmlPassivoCirc;

            const totalPassivoCirc = aPagarCP;
            document.getElementById('tot-passivo-circ').textContent = fmt(totalPassivoCirc);


            // ------------------------------------
            // CALC: PASSIVO NÃO CIRCULANTE
            // ------------------------------------
            const aPagarLP = lancamentos
                .filter(l => (l.tipo === 'Despesa' || l.tipo === 'Saída') && new Date(l.data_vencimento) > anoQueVem)
                .reduce((acc, l) => acc + parse(l.valor), 0);

            let htmlPassivoNao = `
                <div class="conta-item"><span class="conta-nome"><i class="fas fa-landmark"></i> Financiamentos (LP)</span><span class="conta-valor">${fmt(aPagarLP)}</span></div>
            `;
            document.getElementById('lista-passivo-nao').innerHTML = htmlPassivoNao;

            const totalPassivoNao = aPagarLP;
            document.getElementById('tot-passivo-nao').textContent = fmt(totalPassivoNao);


            // ------------------------------------
            // CALC: PATRIMÔNIO LÍQUIDO
            // ------------------------------------
            // PL = ATIVO - PASSIVO
            const totalPassivoExigivel = totalPassivoCirc + totalPassivoNao;
            const totalPL = grandAtivo - totalPassivoExigivel;

            let htmlPL = `
                 <div class="conta-item"><span class="conta-nome"><i class="fas fa-coins"></i> Capital Social (+ Lucros)</span><span class="conta-valor">${fmt(totalPL)}</span></div>
            `;
            document.getElementById('lista-pl').innerHTML = htmlPL;
            document.getElementById('tot-pl').textContent = fmt(totalPL);

            // GRAND TOTAL PASSIVO
            const grandPassivo = totalPassivoExigivel + totalPL;
            document.getElementById('grand-tot-passivo').textContent = fmt(grandPassivo);


            // ------------------------------------
            // INDICADORES & VALIDAÇÃO
            // ------------------------------------
            const validacaoBox = document.getElementById('balanco-validacao');
            const diff = Math.abs(grandAtivo - grandPassivo);

            if (diff < 0.01) {
                validacaoBox.className = 'validacao-box sucesso';
                validacaoBox.innerHTML = '<i class="fas fa-check-circle"></i> Balanço Fechado';
            } else {
                validacaoBox.className = 'validacao-box erro';
                validacaoBox.innerHTML = `<i class="fas fa-exclamation-triangle"></i> Diferença: ${fmt(diff)}`;
            }

            // Liquidez Corrente (AC / PC)
            const liquidez = totalPassivoCirc > 0 ? (totalAtivoCirc / totalPassivoCirc) : 0;
            document.getElementById('ind-liquidez').textContent = liquidez.toFixed(2);

            // Endividamento (Passivo / Ativo)
            const endividamento = grandAtivo > 0 ? ((totalPassivoExigivel / grandAtivo) * 100) : 0;
            document.getElementById('ind-endividamento').textContent = endividamento.toFixed(1) + '%';

            // PL
            const plPerc = grandAtivo > 0 ? ((totalPL / grandAtivo) * 100) : 0;
            document.getElementById('ind-pl').textContent = plPerc.toFixed(1) + '%';


        } catch (e) {
            console.error(e);
            window.FazendaRP.Toast.show('error', 'Erro ao calcular balanço: ' + e.message);
        }
    }
};
